import { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

import { CheckoutSource, checkoutFlowPaths, SourcePathConfig } from '@lib/url/checkout'

const sourcePathsArray = Object.entries(checkoutFlowPaths) as [CheckoutSource, SourcePathConfig][]

const useCheckoutSource = (): CheckoutSource => {
  const location = useLocation()
  const pathname = location.pathname

  return useMemo(
    () => sourcePathsArray.find(([_, path]) => matchPath(path.checkoutPath, pathname))?.[0] ?? CheckoutSource.Search,
    [pathname],
  )
}

export const getSourcePath = (source: CheckoutSource): string => {
  return checkoutFlowPaths[source].sourcePath
}

export default useCheckoutSource
